import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListCollectionChallengesWithClipsRequest } from './list-collection-challenges-with-clips-request';
import type { IListCollectionChallengesWithClipsResponse } from './list-collection-challenges-with-clips-response';
import { listCollectionChallengesWithClipsResponseSchema } from './list-collection-challenges-with-clips-response';

export async function listCollectionChallengesWithClipsApi({
  id,
}: IListCollectionChallengesWithClipsRequest): Promise<
  IValidatedResponse<IListCollectionChallengesWithClipsResponse>
> {
  return getRequest<IListCollectionChallengesWithClipsResponse>({
    path: `/sys/collections/${id}/challenges-with-clips`,
    schema: listCollectionChallengesWithClipsResponseSchema,
  });
}
